import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import UsePointsPage from './UsePointsPage';

export const prefix = 'bm-p-privilege';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: UsePointsPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
